export default "__VITE_ASSET__e0ehaJIf__"